/* eslint-disable no-console */
import {IPaginatedResult, IPaginatedSearch} from '../incase-domain/search';
import {httpDelete, httpGet, httpPost} from './http.service';
import {IConversation, IMessage} from '../incase-domain/message';

const API_BASE_MESSAGES = 'editor/messages';

export const fetchConversations = (paginatedSearch: IPaginatedSearch): Promise<IPaginatedResult<IConversation>> => {
    const {pageNumber, pageSize, ...searchObj} = paginatedSearch;
    return httpPost(`${API_BASE_MESSAGES}/conversations/${pageNumber}/${pageSize}`, searchObj).catch((error) => {
        console.log(error);
    });
};

export const getConversation = (participants: IConversation['participantsDetailed']): Promise<IConversation> => {
    return httpPost(`${API_BASE_MESSAGES}/conversation`, participants);
};

export const fetchMessages = (conversationId: string, paginatedSearch: IPaginatedSearch): Promise<IPaginatedResult<IMessage>> => {
    const {pageNumber, pageSize, ...searchObj} = paginatedSearch;
    return httpPost(`${API_BASE_MESSAGES}/conversations/${conversationId}/messages/${pageNumber}/${pageSize}`, searchObj).catch((error) => {
        console.log(error);
    });
};

export const fetchUnseenMessages = (conversationId: string): Promise<IMessage[]> => {
    return httpGet(`${API_BASE_MESSAGES}/conversations/${conversationId}/messages/unseen`).catch((error) => {
        console.log(error);
    });
};

export const sendMessage = (message: IMessage): Promise<void> => {
    return httpPost(`${API_BASE_MESSAGES}/send-message`, {message}).catch((error) => {
        console.log(error);
    });
};

export const markConversationAsSeen = (conversationId: string): Promise<void> => {
    return httpPost(`${API_BASE_MESSAGES}/conversations/${conversationId}/mark-as-seen`).catch((error) => {
        console.log(error);
    });
};

export const deleteConversation = (conversationId: string): Promise<{success: boolean}> => {
    return httpDelete(`${API_BASE_MESSAGES}/conversations/${conversationId}`, {})
        .then(() => {
            return {success: true};
        })
        .catch((error) => {
            console.log(error);
            return {success: false};
        });
};
